<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    @delete-cancel-action="cancelAction"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
    :readOnly="readOnly"
  >
    <p v-if="this.entry.customer"> Você tem certeza que deseja deletar a venda ao cliente <b>{{this.entry.customer.name}}</b>, no valor de <b>{{this.entry.totalPrice  | formatCurrency }}</b>?</p>
    <p v-else> Você tem certeza que deseja deletar a venda sem cliente, no valor de <b>{{this.entry.totalPrice  | formatCurrency }}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  methods: {
    destroyServerEntry: function(sale) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: DESTROY_SALE_MUTATION,
            variables: {
              id: sale.id,
            }
          })
          .then(response => {
            var errors = response.data.destroySale.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
    cancelAction: function() {
      this.$emit('entry-canceled');
    }
  }
}
const DESTROY_SALE_MUTATION = gql `
  mutation($id: ID!) {
    destroySale(id: $id) {
      cashFlow {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>
